import { StudentParent } from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";

export async function getStudentParents(studentNo: string) {
    try {
        const response = await portalApi.get<StudentParent[]>(`/students/${studentNo}/parents`);
        return response.data
    } catch (error) {
        console.error("Error fetching student parents:", error);
        throw error;
    }
}

type ParentPortalAccount = {
    idParent: number;
    firstName: string;
    surname: string;
    emailAddress: string;
    hasRegisteredAccount: boolean;
}

export async function getStudentParentPortalAccounts(studentNo: string) {
    try {
        const response = await portalApi.get<ParentPortalAccount[]>(`/students/${studentNo}/parent-portal-accounts`);
        return response.data
    } catch (error) {
        console.error("Error fetching student parent portal accounts:", error);
        throw error;
    }
}

export async function addParentToStudent(parentId: string, studentNo: string): Promise<void> {
    try {
        await portalApi.post(`/students/${studentNo}/parents`, { idParent: parentId });
    } catch (error) {
        console.error("Error adding parent to student:", error);
        throw error;
    }
}

export async function removeParentFromStudent(parentId: string, studentNo: string): Promise<void> {
    try {
        await portalApi.delete(`/students/${studentNo}/parents`, { data: { idParent: parentId } });
    } catch (error) {
        console.error("Error removing parent from student:", error);
        throw error;
    }
}
